import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { HelpHint } from "@/components/HelpHint";
import { Plus, Trash2 } from "lucide-react";

// Settings -> Meeting Locations tab. Extracted from Settings.js so each
// settings section owns its own presentational block; all state/handlers
// remain owned by the parent Settings page (props-driven, no behavior change).
export const MeetingLocationsSection = ({
  locations,
  newLocation,
  onRenameLocation,
  onToggleActive,
  onRemoveUnsaved,
  onNewLocationChange,
  onAddLocation,
  onSave,
  saving,
}) => (
  <>
    <div className="flex items-center gap-1.5">
      <h2 className="font-heading text-lg font-semibold">Meeting Locations</h2>
      <HelpHint text="Students choose one of these as their default pickup location; you can add, rename, or disable locations anytime." testId="meeting-locations-help" />
    </div>
    <div className="space-y-2" data-testid="meeting-locations-list">
      {locations.map((loc) => (
        <div key={loc.id} className="flex items-center gap-2 rounded-lg border p-2.5" data-testid="meeting-location-row">
          <Input value={loc.name} onChange={(e) => onRenameLocation(loc.id, e.target.value)} className="flex-1" data-testid="meeting-location-name-input" />
          <Badge variant="outline" className={loc.active ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-zinc-200 bg-zinc-100 text-zinc-600"}>
            {loc.active ? "Active" : "Disabled"}
          </Badge>
          <Switch checked={loc.active} onCheckedChange={() => onToggleActive(loc.id)} data-testid="meeting-location-active-switch" />
          {String(loc.id).startsWith("new-") && (
            <Button size="icon" variant="ghost" onClick={() => onRemoveUnsaved(loc.id)} data-testid="meeting-location-remove-button">
              <Trash2 className="h-4 w-4 text-destructive" />
            </Button>
          )}
        </div>
      ))}
    </div>
    <div className="flex items-center gap-2 pt-1">
      <Label className="sr-only" htmlFor="new-location-input">New location name</Label>
      <Input id="new-location-input" placeholder="Add a new location, e.g. Rockford" value={newLocation} onChange={(e) => onNewLocationChange(e.target.value)} data-testid="new-meeting-location-input" />
      <Button variant="outline" onClick={onAddLocation} data-testid="add-meeting-location-button">
        <Plus className="h-4 w-4 mr-1" /> Add
      </Button>
    </div>
    <div className="pt-2 border-t">
      <Button onClick={onSave} disabled={saving} className="bg-[hsl(var(--role-accent))] hover:opacity-95" data-testid="settings-save-button">
        {saving ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  </>
);
